import { Spin } from "antd";
import { useDocumentLink } from "../hooks/use-document-link";
import { Table } from "../../../components";
import ColumnGroup from "antd/lib/table/ColumnGroup";
import Column from "antd/lib/table/Column";

export const ShortDocumentLinkTable = () => {
  const { shortDocumentLinkData, isLoading } = useDocumentLink();

  if (isLoading) return <Spin />;

  return (
    <Table dataSource={shortDocumentLinkData} bordered>
      <ColumnGroup title="Tài liệu bên ngoài">
        <Column width={280} title="Mã tài liệu" dataIndex="docCode" key="docCode" />
        <Column width={280} title="Tên tài liệu" dataIndex="Title" key="Title" />
      </ColumnGroup>
      <ColumnGroup title="Tài liệu SQMS (tài liệu nội bộ đã liên kết)">
        <Column width={280} title="Mã tài liệu" dataIndex="docLinkCode" key="docLinkCode" />
        <Column width={280} title="Tên tài liệu" dataIndex="docLinkTitle" key="docLinkTitle" />
      </ColumnGroup>
    </Table>
  );
};
